import { render, staticRenderFns } from "./yc-harvest.vue?vue&type=template&id=5523c180&scoped=true&"
import script from "./yc-harvest.vue?vue&type=script&lang=js&"
export * from "./yc-harvest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5523c180",
  null
  
)

export default component.exports